package nl.volleyplanner.web.base.component

import kotlinx.dom.addClass
import kotlinx.dom.hasClass
import kotlinx.dom.removeClass
import kotlinx.html.*
import kotlinx.html.js.onClickFunction
import nl.volleyplanner.web.base.IconPosition
import nl.volleyplanner.web.base.icon
import nl.volleyplanner.web.util.BootstrapColor
import org.w3c.dom.HTMLSpanElement

enum class BadgeStyle(val cssStyle: String?) {
    Default(null),
    RoundedPill("rounded-pill"),
}

fun FlowOrPhrasingContent.badge(color: BootstrapColor, style: BadgeStyle = BadgeStyle.Default, small: Boolean = false, soft: Boolean = false, block: SPAN.() -> Unit) {
    span(classes = "badge d-inline-flex align-items-center me-1") {
        classes += color.textBgColorClass.let { if (soft) "$it-soft" else it }
        if (style.cssStyle != null) {
            classes += style.cssStyle
        }
        if (small) classes += "small"
        block()
    }
}



fun FlowOrPhrasingContent.badgeToggle(
    label: String,
    htmlId: String? = null,
    selected: Boolean = false,
    dataAttributes: Map<String, String> = emptyMap(),
    onChangeFunction: (isSelected: Boolean) -> Unit = {}
) {
    val color = when (selected) {
        true -> BootstrapColor.Primary
        else -> BootstrapColor.Secondary
    }
    badge(color, style = BadgeStyle.RoundedPill) {
        classes += "vp-badge-toggle"
        role = "button"
        if (htmlId != null) {
            id = htmlId
        }
        attributes.putAll(dataAttributes)
        onClickFunction = { event ->
            event.preventDefault()
            val badgeElement = event.currentTarget as HTMLSpanElement
            val currentSelectedValue = badgeElement.hasClass(BootstrapColor.Primary.textBgColorClass)
            if (currentSelectedValue) {
                badgeElement.removeClass(BootstrapColor.Primary.textBgColorClass)
                badgeElement.addClass(BootstrapColor.Secondary.textBgColorClass)
                val iconElement = badgeElement.querySelector(".bi-dash-circle-fill")!!
                iconElement.removeClass("bi-dash-circle-fill")
                iconElement.addClass("bi-plus-circle-fill")
            } else {
                badgeElement.addClass(BootstrapColor.Primary.textBgColorClass)
                badgeElement.removeClass(BootstrapColor.Secondary.textBgColorClass)
                val iconElement = badgeElement.querySelector(".bi-plus-circle-fill")!!
                iconElement.addClass("bi-dash-circle-fill")
                iconElement.removeClass("bi-plus-circle-fill")
            }
            onChangeFunction.invoke(currentSelectedValue.not())
        }
        +label
        if (!selected) {
            icon("bi-plus-circle-fill", iconPosition = IconPosition.End)
        } else {
            icon("bi-dash-circle-fill", iconPosition = IconPosition.End)
        }
    }
}